import script from "./ViewSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ViewSelector.vue?vue&type=style&index=0&id=7ba0fd2f&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba0fd2f"]])

export default __exports__